import React from "react";
import {ButtonIconEdit, SelectField} from "../../../Components/Inputs";
import {allow, policyEvents} from "../../../Components/Authorize";
import {HtmlDisplay} from "../../../Components/Display";
import {getApprovalStatusList} from "../approvalConstants";
import {locations} from "../../../Utilities/Location";
import { ButtonIconPackingList } from "@/Components/Inputs/Buttons/ButtonIcon/ButtonIcon";
import { truncateString } from "@/Utilities/commonUtilities";

interface UserApprovalRowProps {
    onApprovalStatusClick: (userId: string, value: string | number) => void;
    handleOpenEditDialog: (event: React.MouseEvent<HTMLElement>, user: Record<string, any>) => void;
    redirect: (path: string) => void;
    user: Record<string, any>;
}

export const UserApprovalRow: React.FC<UserApprovalRowProps> = ({onApprovalStatusClick, handleOpenEditDialog, redirect, user}) => {

    const handleOnChangeApprovalStatus = (event: React.ChangeEvent<HTMLSelectElement>, userId: string) => {
        event.preventDefault();
        onApprovalStatusClick(userId, event.target.value);
    };

    const canApprove = allow(policyEvents.APPROVE_USERS);

    const handleEditUserDetailsClick = (event?: React.MouseEvent<HTMLElement>, userId?: string) => {
        event?.preventDefault();
        if (userId) redirect(locations.USER_PROFILE.getPath(userId));
    };

    return (
        <tr id={user.userId} data-testid={user.userId}>
            <td>
                {user.email}
            </td>
            <td>
                {user.firstName}
            </td>
            <td>
                {user.lastName}
            </td>
            <td>
                {user.districtName}
            </td>
            <td>
                {user.patronSubTypeName}
            </td>
            <td>
                {user.organization}
            </td>
            <td>
                {truncateString(user.notes)}
            </td>
            <td className={user.approvalStatusName}>
            {
                canApprove ? 
                    user.isActive ? 
                        <SelectField
                            hideLabel
                            includeDefaultOption={false}
                            label={`Approval Status for ${user.firstName}`}
                            name={`approval-status-${user.userId}`}
                            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => handleOnChangeApprovalStatus(event, user.userId)}
                            options={getApprovalStatusList()}
                            value={user.approvalStatus}
                        />
                     : 
                        <HtmlDisplay
                            html={getApprovalStatusList().find(f => f.value === user.approvalStatus)?.text || ``}
                            name={`approval-status-${user.userId}`}
                        />
                    
                 : 
                    <HtmlDisplay
                        html={getApprovalStatusList().find(f => f.value === user.approvalStatus)?.text || ``}
                        name={`approval-status-${user.userId}`}
                    />
                
            }
            </td>
            <td className="align-center">
                <ButtonIconEdit
                    inputDescription={`for ${user.firstName} ${user.lastName}`}
                    onClick={(event) => handleEditUserDetailsClick(event, user.userId)}
                />
                <ButtonIconPackingList
                                inputDescription={`for ${user.firstName} ${user.lastName}`}
                                onClick={(event) => handleOpenEditDialog(event as React.MouseEvent<HTMLElement>, user)}
                            />
            </td>
        </tr>
    );
};
